import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LANGUAGES = [
  { id: "no", label: "NO" },
  { id: "en", label: "EN" },
  { id: "pl", label: "PL" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("nc_lang") || "no";
    } catch {
      return "no";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("nc_lang", lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const lookup = (obj) => path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
    return lookup(translations[lang]) ?? lookup(translations.no) ?? path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
